/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-file-catalog': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.25 1.25H5c-.69 0-1.25.56-1.25 1.25V5H2.5v1.25h1.25v3.125H2.5v1.25h1.25v3.125H2.5V15h1.25v2.5c0 .69.56 1.25 1.25 1.25h11.25c.69 0 1.25-.56 1.25-1.25v-15c0-.69-.56-1.25-1.25-1.25zm0 16.25H5V15h1.25v-1.25H5v-3.125h1.25v-1.25H5V6.25h1.25V5H5V2.5h11.25v15zM8.75 5h5v1.25h-5V5zm0 4.375h5v1.25h-5v-1.25zm0 4.375h5V15h-5v-1.25z"/>'
  }
})
